import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, Mail } from "lucide-react";
import { BUSINESS_INFO } from "../lib/constants";
import PatternStrip from "./PatternStrip";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-elle-green text-elle-cream" data-testid="site-footer">
      <PatternStrip height={10} className="opacity-80" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif-display text-5xl leading-none">Ell'e</div>
          <div className="font-body text-[10px] tracking-overline uppercase mt-2 text-elle-cream/70">
            Coffee · Sidama, Ethiopia
          </div>
          <p className="mt-8 text-elle-cream/80 max-w-md leading-relaxed text-[15px]">
            Ell'e means "what I have seen." Born in the mist-covered highlands
            of Sidama, our coffee carries generations of land, family and
            ceremony — from Maya's hands to your cup.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] tracking-overline uppercase text-elle-cream/60 mb-5">
            Explore
          </div>
          <ul className="space-y-3 text-[14px]">
            <li><Link to="/" className="link-underline" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/shop" className="link-underline" data-testid="footer-link-shop">Shop</Link></li>
            <li><Link to="/about" className="link-underline" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/contact" className="link-underline" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] tracking-overline uppercase text-elle-cream/60 mb-5">
            Coffees
          </div>
          <ul className="space-y-3 text-[14px]">
            <li><Link to="/product/sidamo" className="link-underline" data-testid="footer-link-sidamo">Sidamo</Link></li>
            <li><Link to="/product/yirgacheffe" className="link-underline" data-testid="footer-link-yirgacheffe">Yirgacheffe</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-overline uppercase text-elle-cream/60 mb-5">
            Connect
          </div>
          <a
            href={`mailto:${BUSINESS_INFO.email}`}
            className="flex items-center gap-2 text-[14px] link-underline mb-3"
            data-testid="footer-email"
          >
            <Mail size={14} /> {BUSINESS_INFO.email}
          </a>
          <div className="text-[13px] text-elle-cream/70 mb-5">
            {BUSINESS_INFO.location}
          </div>
          <div className="flex items-center gap-4 mt-2">
            <a href={BUSINESS_INFO.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-elle-gold transition-colors" data-testid="footer-instagram"><Instagram size={18} /></a>
            <a href={BUSINESS_INFO.twitter} target="_blank" rel="noreferrer" aria-label="Twitter" className="hover:text-elle-gold transition-colors" data-testid="footer-twitter"><Twitter size={18} /></a>
            <a href={BUSINESS_INFO.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-elle-gold transition-colors" data-testid="footer-facebook"><Facebook size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-elle-cream/15">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-elle-cream/60">
          <div>© {year} Ell'e Coffee. All rights reserved.</div>
          <div className="tracking-overline uppercase">From Sidama to your cup</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
